export const positions = [
  { position: 'C' },
  { position: '1B' },
  { position: '2B' },
  { position: '3B' },
  { position: 'SS' },
  { position: 'LF' },
  { position: 'CF' },
  { position: 'RF' },
  { position: 'DH' },
  { position: 'P' },
  { position: 'INF' },
  { position: 'OF' },
  { position: 'UT' },
];
// export const positions = [
//   {
//     position: '3b/c',
//   },
//   {
//     position: 'ph/2b',
//   },
//   {
//     position: 'rf',
//   },
//   {
//     position: '3b/pr',
//   },
//   {
//     position: 'PH/C',
//   },
//   {
//     position: 'pr/3b',
//   },
//   {
//     position: 'p/ss',
//   },
//   {
//     position: 'P',
//   },
//   {
//     position: 'CF',
//   },
//   {
//     position: 'OF',
//   },
//   {
//     position: '3b/p',
//   },
//   {
//     position: 'lf/pr',
//   },
//   {
//     position: 'PH/RF',
//   },
//   {
//     position: 'PH/SS',
//   },
//   {
//     position: 'lf/1b',
//   },
//   {
//     position: 'c',
//   },
//   {
//     position: 'pr/lf',
//   },
//   {
//     position: 'SS/P',
//   },
//   {
//     position: 'dh/rf',
//   },
//   {
//     position: 'pr/c',
//   },
//   {
//     position: 'cf/lf',
//   },
//   {
//     position: 'cf/rf',
//   },
//   {
//     position: 'PH/LF',
//   },
//   {
//     position: 'DH/1B',
//   },
//   {
//     position: 'ph',
//   },
//   {
//     position: 'dh/ph',
//   },
//   {
//     position: 'lf/rf',
//   },
//   {
//     position: 'PR/2B',
//   },
//   {
//     position: '1b',
//   },
//   {
//     position: 'lf',
//   },
//   {
//     position: 'RF',
//   },
//   {
//     position: 'ph/lf',
//   },
//   {
//     position: 'UT',
//   },
//   {
//     position: '2b/3b',
//   },
//   {
//     position: '3B',
//   },
//   {
//     position: 'pr/1b',
//   },
//   {
//     position: 'dh/2b',
//   },
//   {
//     position: 'pr/rf',
//   },
//   {
//     position: 'ph/c',
//   },
//   {
//     position: '2b',
//   },
//   {
//     position: 'PH/2B',
//   },
//   {
//     position: 'INF',
//   },
//   {
//     position: 'dh',
//   },
//   {
//     position: 'pr/cf',
//   },
//   {
//     position: 'pr/dh',
//   },
//   {
//     position: 'SS',
//   },
//   {
//     position: 'PR',
//   },
//   {
//     position: '3B/1B',
//   },
//   {
//     position: 'p/dh',
//   },
//   {
//     position: 'cf',
//   },
//   {
//     position: '1B/RF',
//   },
//   {
//     position: 'DH',
//   },
//   {
//     position: 'ss/2b',
//   },
//   {
//     position: 'PR/DH',
//   },
//   {
//     position: '2b/rf',
//   },
//   {
//     position: 'PH/3B',
//   },
//   {
//     position: 'ph/cf',
//   },
//   {
//     position: '2B',
//   },
//   {
//     position: 'dh/c',
//   },
//   {
//     position: 'PH',
//   },
//   {
//     position: 'C',
//   },
//   {
//     position: 'ph/3b',
//   },
//   {
//     position: 'pr',
//   },
//   {
//     position: 'ph/dh',
//   },
//   {
//     position: 'ss/p',
//   },
//   {
//     position: 'ph/1b',
//   },
//   {
//     position: 'pr/2b',
//   },
//   {
//     position: '3b',
//   },
//   {
//     position: 'p',
//   },
//   {
//     position: 'pr/ss',
//   },
//   {
//     position: 'ph/rf',
//   },
//   {
//     position: 'LF',
//   },
//   {
//     position: 'rf/lf',
//   },
//   {
//     position: 'cf/p',
//   },
//   {
//     position: 'rf/p',
//   },
//   {
//     position: 'PH/CF',
//   },
//   {
//     position: 'ss',
//   },
//   {
//     position: 'lf/cf',
//   },
//   {
//     position: '1B',
//   },
//   {
//     position: 'ph/ss',
//   },
// ];
